module.exports = __webpack_public_path__ + "img/right_angle_corner_icon.7e892ce5.svg";